module.exports = __webpack_public_path__ + "img/border1.c29944db.png";